/**
 * #instance_settings.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
import _m0 from "protobufjs/minimal.js";
import { GetFieldsRequest, GetFieldsResponse, ValidateFormRequest, ValidateFormResponse } from "./shared.js";
export const InstanceSettingsServiceName = "devvit.actor.settings.v1alpha.InstanceSettings";
export class InstanceSettingsClientImpl {
    constructor(rpc, opts) {
        this.service = opts?.service || InstanceSettingsServiceName;
        this.rpc = rpc;
        this.GetSettingsFields = this.GetSettingsFields.bind(this);
        this.ValidateForm = this.ValidateForm.bind(this);
    }
    GetSettingsFields(request, metadata) {
        const data = GetFieldsRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "GetSettingsFields", data, metadata);
        return promise.then((data) => GetFieldsResponse.decode(_m0.Reader.create(data)));
    }
    ValidateForm(request, metadata) {
        const data = ValidateFormRequest.encode(request).finish();
        const promise = this.rpc.request(this.service, "ValidateForm", data, metadata);
        return promise.then((data) => ValidateFormResponse.decode(_m0.Reader.create(data)));
    }
}
export const InstanceSettingsDefinition = {
    name: "InstanceSettings",
    fullName: "devvit.actor.settings.v1alpha.InstanceSettings",
    methods: {
        /** Requested by the platform when rendering the form to configure this actor */
        getSettingsFields: {
            name: "GetSettingsFields",
            requestType: GetFieldsRequest,
            requestStream: false,
            responseType: GetFieldsResponse,
            responseStream: false,
            options: {},
        },
        /** Called by the platform to allow more advanced verification of fields */
        validateForm: {
            name: "ValidateForm",
            requestType: ValidateFormRequest,
            requestStream: false,
            responseType: ValidateFormResponse,
            responseStream: false,
            options: {},
        },
    },
};
